"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/APIKeys/components/CreateAPIKeyModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _noticeBar = require('web/services/context/noticeBar');
var _ui = require('web/services/ui');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _helpers = require('../helpers');
















// Creates a key, then shows its secret once. Choosing "Never" asks once
// more before anything is sent. While the key is being created, nothing
// closes the dialog; once the secret shows, only Done does. So a stray
// click or Esc can't lose the only copy of the secret.
const CreateAPIKeyModal = ({ orgs, isOpen, onClose, onProceed }) => {
  const [name, setName] = _react.useState.call(void 0, '')
  // null: every org, including ones added later.
  const [limitTo, setLimitTo] = _react.useState(null)
  const [scopes, setScopes] = _react.useState([])
  const [expires, setExpires] = _react.useState(_helpers.DEFAULT_EXPIRY)
  const [isConfirmingNever, setIsConfirmingNever] = _react.useState.call(void 0, false)
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const [secret, setSecret] = _react.useState(null)
  const [isRevealed, setIsRevealed] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const dismiss = isLoading ? undefined : onClose

  const toggleScope = (scope) => setScopes(s => s.includes(scope)
    ? s.filter(x => x !== scope)
    // Kept in the listed order, so the key's scopes read the same way.
    : _helpers.SCOPE_OPTIONS.map(o => o.value).filter(x => x === scope || s.includes(x)))

  const toggleOrg = (orgKey) => setLimitTo(ks => ks && (ks.includes(orgKey)
    ? ks.filter(k => k !== orgKey)
    : orgs.map(o => o.OrgKey).filter(k => k === orgKey || ks.includes(k))))

  const send = () => {
    setIsLoading(true)
    setIsConfirmingNever(false)
    onProceed({ Name: name.trim(), Scopes: scopes, Expires: expires, ...(limitTo && { Orgs: limitTo }) })
      .then(r => setSecret(r.Secret))
      .catch(() => showWarningBar('Failed to create the API key.'))
      .finally(() => setIsLoading(false))
  }

  const onCreate = () => expires === 'never' ? setIsConfirmingNever(true) : send()

  const copy = () => secret && _ui.copyToClipboard.call(void 0, secret)
    .then(() => showSuccessBar('Copied the API key.'))
    .catch(() => showWarningBar("Couldn't copy the API key. Select it and copy it instead."))

  // D-118: shown once, masked until revealed, never again; only a hash is
  // stored, so a lost key is replaced, not recovered.
  if (secret) {
    return (
      _react2.default.createElement(_Modal2.default, { isOpen: isOpen, title: "Copy your new API key"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
        , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}, "This is the only time you'll see this key. Copy it now and store it safely, for example in your secrets manager."

        )
        , _react2.default.createElement('div', { className: "settings--org-api-keys--secret", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
          , _react2.default.createElement('code', { 'aria-label': isRevealed ? 'API key' : 'API key, hidden', __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}},  isRevealed ? secret : _helpers.maskSecret.call(void 0, secret) )
          , _react2.default.createElement('button', {
            type: "button",
            className: _classBuilder2.default.call(void 0, 'settings--org-api-keys--icon-btn', 'settings--org-api-keys--reveal', isRevealed && 'settings--org-api-keys--reveal--on'),
            'aria-label': isRevealed ? 'Hide API key' : 'Show API key',
            'aria-pressed': isRevealed,
            title: isRevealed ? 'Hide' : 'Show',
            onClick: () => setIsRevealed(r => !r), __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
          )
          , _react2.default.createElement('button', {
            type: "button",
            className: "settings--org-api-keys--icon-btn settings--org-api-keys--copy" ,
            'aria-label': "Copy API key"  ,
            title: "Copy",
            onClick: copy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
          )
        )
        , _react2.default.createElement(_Modal.ModalDesc, { className: "settings--org-api-keys--secret-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "BloomText won't show it again. If it's lost, create a new key and revoke this one."

        )
        , _react2.default.createElement(_Modal.ModalControls, { primaryBtnLabel: "Done", onPrimaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}} )
      )
    )
  }

  if (isConfirmingNever) {
    return (
      _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: dismiss, title: `Never expire "${name.trim()}"?`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
        , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}, "Keys that never expire stay valid until someone revokes them. If this key leaks, anyone can use it until then."


        )
        , _react2.default.createElement(_Modal.ModalControls, {
          primaryBtnTheme: "danger",
          primaryBtnLabel: "Never expire" ,
          isPrimaryLoading: isLoading,
          onPrimaryBtnClick: send,
          secondaryBtnLabel: "Cancel",
          onSecondaryBtnClick: () => setIsConfirmingNever(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
        )
      )
    )
  }

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: dismiss, title: "Create API key"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}
      , _react2.default.createElement('label', { className: "settings--org-api-keys--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}, "Name"

        , _react2.default.createElement(_Form.TextInput, {
          autoFocus: true,
          value: name,
          maxLength: 100,
          onChange: e => setName(e.target.value),
          placeholder: "E.g. Reminder service"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
        )
      )
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}, "Messages the key sends come from this name, so staff know where they came from."              )
      ,  orgs.length > 1 && (
        _react2.default.createElement('fieldset', { className: "settings--org-api-keys--scopes", __self: this, __source: {fileName: _jsxFileName, lineNumber: 136}}
          , _react2.default.createElement('legend', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}, "Organizations")
          , _react2.default.createElement(_Form.Toggle, {
            label: "All organizations" ,
            hint: "Including ones added later. Calls must name one with org_id."         ,
            isChecked: limitTo === null,
            onChange: all => setLimitTo(all ? null : []), __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
          )
          , _react2.default.createElement(_Form.Toggle, {
            className: "settings--org-api-keys--orgs-toggle",
            label: "Only these organizations"  ,
            hint: limitTo === null ? orgs.map(o => o.Name).join(', ') : undefined,
            isChecked: limitTo !== null,
            onChange: only => setLimitTo(only ? [] : null), __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}
          )
          ,  limitTo && orgs.map(o => (
            _react2.default.createElement('label', { key: o.OrgKey, className: "settings--org-api-keys--scope", __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}
              , _react2.default.createElement('input', { type: "checkbox", checked: limitTo.includes(o.OrgKey), onChange: () => toggleOrg(o.OrgKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}} )
              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 154}},  o.Name )
            )
          ))
        )
      )
      , _react2.default.createElement('fieldset', { className: "settings--org-api-keys--scopes", __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}
        , _react2.default.createElement('legend', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}, "Scopes")
        ,  _helpers.SCOPE_OPTIONS.map(o => (
          _react2.default.createElement('label', { key: o.value, className: "settings--org-api-keys--scope", __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}
            , _react2.default.createElement('input', { type: "checkbox", checked: scopes.includes(o.value), onChange: () => toggleScope(o.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}} )
            , _react2.default.createElement('code', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 164}},  o.value )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 165}},  o.label )
          )
        ))
      )
      , _react2.default.createElement('label', { className: "settings--org-api-keys--expiry-field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}, "Expires in"

        , _react2.default.createElement(_Form.SimpleSelect, { value: expires, onChange: setExpires, options: _helpers.EXPIRY_OPTIONS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}} )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Create key" ,
        isPrimaryEnabled: !!name.trim() && scopes.length > 0 && (limitTo === null || limitTo.length > 0),
        isPrimaryLoading: isLoading,
        onPrimaryBtnClick: onCreate,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}
      )
    )
  )
}

exports. default = CreateAPIKeyModal
